'use client';
import React from 'react';
import { MarketingPageComponentProps } from '@services/launches/fetchLaunchMarketingContent';
import CommonDynamicIntroduction from '../CommonDynamicIntroduction';
import cn from './style.module.scss';
export default function TheResidencesIntroduction(
  props: MarketingPageComponentProps
) {
  return (
    <CommonDynamicIntroduction
      backgroundImage={props.images.westminster_tower_light_background?.src}
      heading={props.locale.section.residencesTowerWelcomeHeading}
      description={props.locale.section.residencesTowerWelcomeContent}
      headingClassName={cn.theResidencesIntroHeading}
    />
  );
}
